import { render, staticRenderFns } from "./Organazation.vue?vue&type=template&id=fa6a364e&"
import script from "./Organazation.vue?vue&type=script&lang=js&"
export * from "./Organazation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports